import BaseType from "./BaseType";

export default class SchwebetuerFluegel extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
        this.receiveDropable = true;
    }

    onReceiveDrop(product) {
        this.vsData.setProduct(product);
    }

}

